import { ChangeDetectionStrategy, Component, NgZone, ViewChild } from '@angular/core';
import { GuidedTourDirective } from '../../guided-tour.directive';
import { OA_ADMIN_AREA } from '../../../model/guided-tour';
import { GuidedTourService } from '../../../service/guided-tour.service';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { NgIf } from '@angular/common';
import { ModalBridgeComponent } from '@markant-platform/shared/ui-modal';
import { SectionStartDialogComponent } from '../../../section-start-dialog/section-start-dialog.component';
import { Router } from '@angular/router';
import { generalInformationSteps } from './general-information-steps';
import { GuidedTourWrapperComponent } from '../../guided-tour-wrapper.component';

@Component({
  selector: 'markant-platform-general-information',
  templateUrl: './general-information.component.html',
  styleUrls: ['./general-information.component.scss'],
  standalone: true,
  imports: [
    MarkantElementsModule,
    TranslocoModule,
    NgIf,
    ModalBridgeComponent,
    SectionStartDialogComponent,
    GuidedTourWrapperComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneralInformationComponent extends GuidedTourDirective {
  @ViewChild(GuidedTourWrapperComponent, { static: true }) guidedTourComponent!: GuidedTourWrapperComponent;

  readonly generalInformationSteps = generalInformationSteps;
  showStartDialog = true;

  backButtonCallback = this.previousTarget.bind(this);
  nextButtonCallback = this.nextTarget.bind(this);

  constructor(
    guidedService: GuidedTourService,
    protected override router: Router,
    private ngZone: NgZone
  ) {
    super(OA_ADMIN_AREA, 1, guidedService, router);
  }

  override async nextTarget(): Promise<void> {
    super.nextTarget();
    switch (this.currentStep) {
      case 1:
        await this.guidedTourComponent.start();
        break;
      case 2:
        this.showStartDialog = false;
        await this.guidedTourComponent.next();
        break;
      case 3:
        await this.guidedTourComponent.next();
        break;
      case 4:
        await this.guidedTourComponent.end();
        await this.guidedTourService.completeSection(this.guidedTour.id, this.sectionNumber, true);
        break;
    }
  }

  override async previousTarget(): Promise<void> {
    super.previousTarget();
    switch (this.currentStep) {
      case 0:
        await this.cancelSection();
        break;
      case 1:
        this.showStartDialog = true;
        await this.guidedTourComponent.jumpTo(this.currentStep - 1);
        break;
      case 2:
        await this.guidedTourComponent.jumpTo(this.currentStep - 1);
        await this.router.navigate(['']);
        break;
    }
  }

  protected override async cancelSection(): Promise<void> {
    await this.guidedTourComponent.end();
    super.cancelSection();
  }
}
